export default __webpack_public_path__ + "locales/es/HotkeysPanel.json?hash=1ef2e17ee8a16d4874d50047855e0286";